import React, { useState, useEffect, useContext, useRef } from 'react';
import ENVIRONMENT from '../../../../environments';
import * as Constants from "../../CustomerComponents/Constants";
import { Tooltip, Row, Card, Col, Upload, Button, message, Empty } from 'antd';
import { CloseOutlined, LoadingOutlined, InfoCircleOutlined, FlagOutlined, ArrowRightOutlined, ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons';
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';
import * as Styles from "../../../../Styles";
import ZoomImage from '../ProductComponents/imageZoomable';
import FileConstants from '../../../../FileConstants';
import AWS from "aws-sdk";
import axios from 'axios';
import { BUCKET_NAME, DEFAULT_BASE_URL, IDENTITY_POOL_ID, USER_POOL_ID, getBaseURL } from '../../../../environments/env';
import ProductPageConstants from '../ProductComponents/ProductPageConstants';
import * as JSZip from 'jszip';
import * as Utilities from '../../Utilities';

const progress_bar = Styles.progress_bar;

const CUSTOMER_USERNAME = localStorage.getItem('username');
const COMPANY_ID = localStorage.getItem("company_id");
const SHARED_ENTITIES = localStorage.getItem("shared_entities");
const MANAGED_CUSTOMER_USERNAME = localStorage.getItem('managed_customer_username');
const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');
const IS_MS_PROVIDER = localStorage.getItem("is_msprovider") === 'true' ? true : false;

const blobResolvers = new Map(); // key: viewerId, value: resolve(blob)

const ProductComparisonViewer = () => {
    const { compareView, setCompareView, previewAssets, setPreviewAssets, referenecAssets, setReferenceAssets,
        selectedPreviewAsset, setSelectedPreviewAsset, selectedReferenceAsset, setSelectedReferenceAsset,
        previewModelSelected, setPreviewModelSelected, referenceModelSelected, setReferenceModelSelected,
        setTourStep, tourStep, referenceModelStatus, setReferenceModelStatus, model3DStatus, setModel3DStatus,
        previewImageLoader, setPreviewImageLoader, refImageLoader, setRefImageLoader, signedUrl, setSignedUrl,
        ifIframeLoadedOnce, setIfIframeLoadedOnce, referenceImageLoader, setReferenceImageLoader,
        getMetadata, getDownloadUrl, setViewType, setRefImgModal, getProductQAImagery, productAssetData,
        allProductQAImages, firstTimeLoadedRefAssets, selectRelevantImage, productData, access_level,
        productRefImages, product_id, productQAImages, viewType, rejectedZips, initialLoader,
        setRejectedZips } = useContext(CollaborateQAContext);

    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [snapshotLoader, setSnapshotLoader] = useState(false);
    const [groupedProducts, setGroupedProducts] = useState([]);

    // Fetch grouped products when productData is available
    useEffect(() => {
        if (productData && productData.group_id) {
            let payload = {
                'group_ids': [productData.group_id]
            }
            axios.post(ENVIRONMENT.GROUP_IDS_GET_BATCH, payload)
                .then(res => {
                    let grouped_products = [];
                    res.data.map((item) => {
                        if (item.model_status != "1" && (item.company_id == productData.company_id || item.customer_username == productData.customer_username))
                            grouped_products.push(item)
                    })
                    setGroupedProducts(grouped_products);
                })
        }
    }, [productData]);

    const getGroupedProducts = (baseProductID) => {
        let groupAssets = [];
        if (groupedProducts && groupedProducts.length > 0) {
            groupedProducts.forEach((groupItem) => {
                if (groupItem.model_status >= 4 && groupItem.model_status <= 5) {
                    let glbURL = ENVIRONMENT.ASSET_GLB_URL;
                    let platformURL = groupItem.platform ? getBaseURL(groupItem.platform) : getBaseURL("aws");
                    glbURL = glbURL.replace(ENVIRONMENT.DEFAULT_BASE_URL, platformURL);
                    groupAssets.push({
                        "product_id": groupItem.product_id,
                        "glb_url": glbURL + groupItem.product_id + ".glb",
                        "thumbnail": platformURL + ENVIRONMENT.LOW_RES_QA_IMG_URI + groupItem.product_id + "_HeadOn.jpg",
                        "status": FileConstants.MODEL_STATUS_FOR_TEST_MODE[groupItem.model_status]
                    });
                }
            });
        } else {
            let glbURL = ENVIRONMENT.ASSET_GLB_URL;
            let platformURL = getBaseURL(productData?.platform || "aws");
            glbURL = glbURL.replace(ENVIRONMENT.DEFAULT_BASE_URL, platformURL);
            groupAssets.push({
                "product_id": baseProductID,
                "glb_url": glbURL + baseProductID + ".glb",
                "thumbnail": platformURL + ENVIRONMENT.LOW_RES_QA_IMG_URI + baseProductID + "_HeadOn.jpg",
                "status": FileConstants.MODEL_STATUS_FOR_TEST_MODE[productData?.model_status]
            });
        }
        return groupAssets;
    }

    const filterReferenceAssetsZip = async (productRefImages) => {
        const filtered = await Promise.all(
            productRefImages.map(async (image) => {
                const isSupportedFormat = ['jpg', 'jpeg', 'png', 'glb', 'obj', 'gltf'].includes(image.format);
                const isValidZip = image.format === 'zip' && await checkZipForOBJandGLB(image.link);
                if (!isSupportedFormat && image.format === 'zip' && !isValidZip) {
                    setRejectedZips(prev => new Set(prev).add(image.link));
                }
                return isSupportedFormat || isValidZip ? image : null;
            })
        );

        // Filter out nulls
        const validAssets = filtered.filter(Boolean);
        setReferenceImageLoader(false);
        setReferenceAssets(validAssets);
    }

    const filterReferenceAssets = (reference_images) => {
        const validAssets = reference_images.filter((image) =>
            ['jpg', 'jpeg', 'png', 'glb', 'obj', 'zip', 'gltf'].includes(image.format) &&
            !rejectedZips.has(image.link)
        );
        setReferenceAssets(validAssets);
    };


    useEffect(() => {
        if ((!(IS_MS_PROVIDER && (productData?.customer_username == MANAGED_CUSTOMER_USERNAME || productData?.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted" && productData?.model_status == 4)) {

        } else {
            if (viewType == 'comparison_view' && previewAssets?.length > 0) {
                if (Utilities.getCookie(`productQAtourStep2`) == 'true') {
                    setTourStep(-2);
                } else {
                    if (tourStep == 0) {
                        setTourStep(2);
                    }
                }
            }
        }
    }, [viewType, previewAssets, productData, access_level]);


    useEffect(() => {
        setPreviewAssets(productQAImages.filter(image => image.main_type == "low_res_preview"));
        if (firstTimeLoadedRefAssets) {
            if (productRefImages?.length > 0) {
                setReferenceImageLoader(true);
            }
            filterReferenceAssetsZip(productRefImages);

        } else {
            filterReferenceAssets(productRefImages);
        }

    }, [productQAImages, productRefImages, firstTimeLoadedRefAssets]);

    useEffect(() => {
        if (selectedPreviewAsset == null) {
            if (previewAssets?.length > 0) {
                setSelectedPreviewAsset(previewAssets[0]);
            }

            let message = {
                key: ProductPageConstants.MODEL_VIEWER_KEY,
                iframeId: 'model-viewer-3d',
                modelURL: getDownloadUrl("GLB"),
                metadata: getMetadata(),
                configuratorMode: true,
                debugMode: true,
                paddings: [{
                    'target': 'debugPanel',
                    'paddingTop': 36
                }],
                origin: window.location.origin,
                hdri: productData?.company_hdri,
                groupProducts: getGroupedProducts(product_id)
            }

            if (productData?.company_pattern_materials.length > 0) {
                message.patternOptions = productData?.company_pattern_materials;
            }
            open3DViewer('model-viewer-3d', message, 'model-inspector-frame', 'preview');
        }

        if (referenecAssets?.length > 0 && selectedReferenceAsset == null) {
            setSelectedReferenceAsset(referenecAssets[0]);
            if (['glb', 'obj', 'zip'].includes(referenecAssets[0]?.format)) {
                setReferenceModelSelected(true);
                let message = {
                    key: ProductPageConstants.MODEL_VIEWER_KEY,
                    iframeId: 'model-viewer-3d-reference',
                    debugMode: true,
                    modelURL: referenecAssets[0].link,
                    paddings: [{
                        'target': 'debugPanel',
                        'paddingTop': 36
                    }, {
                        'target': 'gizmo',
                        'paddingRight': 130
                    }],
                    origin: window.location.origin,
                    hdri: productData?.company_hdri
                }

                if (productData?.company_pattern_materials.length > 0) {
                    message.patternOptions = productData?.company_pattern_materials;
                }

                open3DViewer('model-viewer-3d-reference', message, 'model-inspector-frame-reference', 'reference');
            }
        }
    }, [previewAssets, referenecAssets])


    const open3DViewer = (viewer_id, message, viewer_window_id, type) => {
        let viewer = document.getElementById(viewer_id);
        let viewer_window = document.getElementById(viewer_window_id);

        console.log('Sent Message &', message)
        console.log(viewer, viewer_window)
        console.log(viewer.contentWindow)
        console.log(viewer_id, getStatus(type), 'model status')

        const sendMessageWithRetry = (retryCount = 0) => {
            if (retryCount > 5) {
                console.error('Failed to resend message after 5 retries');
                return;
            }

            try {
                if (viewer && viewer.contentWindow) {
                    viewer.contentWindow.postMessage(message, "*");
                    console.log('Resent the message successfully to', viewer_id);
                } else {
                    console.log('Resent message viewer not ready, retrying...', retryCount);
                    setTimeout(() => sendMessageWithRetry(retryCount + 1), 500);
                }
            } catch (error) {
                console.error('Error resending message:', error);
                setTimeout(() => sendMessageWithRetry(retryCount + 1), 500);
            }
        };

        if (viewer_window) {
            if (viewer && viewer.contentWindow) {
                if (getStatus(type) == false || viewer_id == 'model-viewer-3d-reference') {
                    viewer.onload = () => {
                        setTimeout(() => {
                            sendMessageWithRetry();
                        }, 300);
                        viewer_window.style.display = 'block';
                        setStatus(type, true);
                    }
                    viewer.src = viewer.src;
                } else {
                    viewer_window.style.display = 'block';
                    setTimeout(() => {
                        sendMessageWithRetry();
                    }, 100);
                }
            } else if (viewer_window != undefined) {
                viewer_window.style.display = 'none';
            }
        } else if (viewer_window != undefined) {
            viewer_window.style.display = 'none';
        }
    }

    function getStatus(key) {
        const entry = ifIframeLoadedOnce.find(obj => obj.hasOwnProperty(key));
        return entry ? entry[key] : false;
    }

    function setStatus(key, value) {
        let reference_array = [...ifIframeLoadedOnce];
        const index = reference_array.findIndex(obj => obj.hasOwnProperty(key));
        if (index !== -1) {
            reference_array[index][key] = value;
        } else {
            reference_array.push({ [key]: value });
        }
        setIfIframeLoadedOnce(reference_array)
    }


    const display_loader_and_set_image = (image_src, type) => {
        if (type == 'preview') {
            setPreviewImageLoader(true);
        } else {
            setRefImageLoader(true);
        }
        const img = new Image();
        img.onload = function () {
            if (type == 'preview') {
                setPreviewImageLoader(false);
                setSelectedPreviewAsset(image_src);
            } else {
                setRefImageLoader(false);
                setSelectedReferenceAsset(image_src);
            }
            forceUpdate();
        }
        img.src = type == 'preview' ? image_src.url : image_src.link;
    }

    const selectPreview = (img, type) => {
        if (type == 'img') {
            display_loader_and_set_image(img, 'preview');
            setPreviewModelSelected(false);
        } else {
            setPreviewModelSelected(true);
            let message = {
                key: ProductPageConstants.MODEL_VIEWER_KEY,
                modelURL: getDownloadUrl("GLB"),
                metadata: getMetadata(),
                iframeId: 'model-viewer-3d',
                configuratorMode: true,
                debugMode: true,
                paddings: [{
                    'target': 'debugPanel',
                    'paddingTop': 36
                }],
                origin: window.location.origin,
                hdri: productData?.company_hdri,
                groupProducts: getGroupedProducts(product_id)
            }

            if (productData?.company_pattern_materials.length > 0) {
                message.patternOptions = productData?.company_pattern_materials;
            }
            open3DViewer('model-viewer-3d', message, 'model-inspector-frame', 'preview');
        }
    }

    useEffect(() => {
        if (groupedProducts && groupedProducts.length > 0) {
            selectPreview(null, 'model');
        }
    }, [groupedProducts]);

    const selectReference = async (img, type, index) => {
        if (type == 'img') {
            display_loader_and_set_image(img, 'reference');
            setReferenceModelSelected(false);
        } else {
            setSelectedReferenceAsset(img);
            setReferenceModelSelected(true);
            let message = {
                key: ProductPageConstants.MODEL_VIEWER_KEY,
                iframeId: 'model-viewer-3d-reference',
                debugMode: true,
                modelURL: img.link,
                paddings: [{
                    'target': 'debugPanel',
                    'paddingTop': 36
                }, {
                        'target': 'gizmo',
                        'paddingRight': 70,
                    }],
                origin: window.location.origin,
                hdri: productData?.company_hdri
            }

            if (productData?.company_pattern_materials.length > 0) {
                message.patternOptions = productData?.company_pattern_materials;
            }

            open3DViewer(`model-viewer-3d-reference`, message, `model-inspector-frame-reference`, `reference`);

        }
    }

    const uploadImage = (key, blobData, callback = undefined) => {
        if (productAssetData?.platform == 'google') {
            uploadtoGoogle(key, blobData, callback = callback)
        } else {
            uploadtoAWS(key, blobData, callback = callback)
        }
    }

    const uploadtoAWS = (key, blobData, callback = undefined) => {
        let buf = Buffer.from(blobData.replace(/^data:image\/\w+;base64,/, ""), 'base64')

        var jwt_token = localStorage.getItem('all3d_jwt_token');
        var cognito_credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: IDENTITY_POOL_ID,
            Logins: {
                [USER_POOL_ID]: jwt_token,
            }
        });
        cognito_credentials.refresh(
            () => {
                AWS.config.update({
                    region: 'us-west-2',
                    credentials: cognito_credentials
                });
                const S3 = new AWS.S3();
                const objParams = {
                    Bucket: BUCKET_NAME,
                    Key: key,
                    ACL: 'public-read',
                    Body: buf,
                    ContentType: "image/png",
                    CacheControl: 'no-cache'
                };


                S3.upload(objParams, (err, data) => {

                    if (callback != undefined) {
                        if (!err) {
                            callback(true);
                        }
                        else {
                            callback(false);
                        }
                    }
                });
            });
    }

    const isSignedURLvalid = (url) => {
        if (url == '')
            return false;
        const urlSearchParams = new URLSearchParams(new URL(url).search);
        const expirationTimeString = urlSearchParams.get('X-Goog-Expires');
        if (!expirationTimeString) {
            console.error('Invalid signed URL: No expiration time found.');
            return false;
        }
        const expirationTime = new Date(parseInt(expirationTimeString) * 1000);
        const currentTime = new Date();
        return currentTime > expirationTime;
    }

    const uploadtoGoogle = (key, blobData, callback = undefined) => {
        let buf = Buffer.from(blobData.replace(/^data:image\/\w+;base64,/, ""), 'base64');
        let path = key;
        console.log(path);

        const handleXhrUpload = (signed_url) => {
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', signed_url, true);

            xhr.onload = function () {
                console.log(xhr);
                if (xhr.status === 200) {
                    console.log("SEND FINISHED", xhr.response);
                    axios.post(ENVIRONMENT.GOOGLE_UPLOAD_CONTROLLER, {
                        'action': 'make_file_public',
                        'file_uri': path
                    }).then(() => {
                        if (callback !== undefined) callback(true);
                    }).catch(() => {
                        if (callback !== undefined) callback(false);
                    });
                } else {
                    if (callback !== undefined) callback(false);
                }
            };

            xhr.onerror = function () {
                if (callback !== undefined) callback(false);
            };

            xhr.send(buf);
        };

        if (isSignedURLvalid(signedUrl)) {
            handleXhrUpload(signedUrl);
        } else {
            axios.post(ENVIRONMENT.GOOGLE_UPLOAD_CONTROLLER, {
                'action': 'get_asigned_urls',
                'file_uri': path
            }).then(res => {
                let signed_url = res.data;
                setSignedUrl(signed_url);
                handleXhrUpload(signed_url);
            }).catch(() => {
                if (callback !== undefined) callback(false);
            });
        }
    };

    const uploadImageAsync = (key, blobData) => {
        return new Promise((resolve, reject) => {
            uploadImage(key, blobData, (success) => {
                if (success) resolve();
                else reject(new Error("Upload failed for " + key));
            });
        });
    };

    const requestBlobFromViewer = (viewerId) => {
        return new Promise((resolve) => {
            blobResolvers.set(viewerId, resolve); // SET FIRST!

            const iframe = document.getElementById(viewerId);
            console.log("Requesting blob from viewer:", viewerId, iframe);

            if (!iframe) {
                blobResolvers.delete(viewerId); // clean up if iframe missing
                return resolve(null);
            }
            setTimeout(() => {
                iframe.contentWindow.postMessage({ getBlob: viewerId }, "*");
            }, 0);

        });
    };


    useEffect(() => {
        const handleOnMessage = (message) => {
            const { blob, id } = message.data?.blob_data || {};
            if (id && blobResolvers.has(id)) {
                console.log("Resolving blob for ID:", id);
                blobResolvers.get(id)(blob); // resolve the promise
                console.log("Blob resolved for ID:", id);
                blobResolvers.delete(id);
                console.log("Blob resolvers after deletion:", blobResolvers);
            }

            if (message.data.type == "model-viewer-status") {
                console.log("Model viewer status ", message?.data);
                if (message.data.status == "ready") {
                    console.log("Model Viewer is ready");
                    if (message.data.iframeId == "model-viewer-3d-reference") {
                        setReferenceModelStatus('ready');
                    } else if (message.data.iframeId == "model-viewer-3d") {
                        setModel3DStatus('ready');
                    }
                } else if (message.data.status == "error") {
                    console.log("Model Viewer is error", message.data.errorMessage);
                    if (message.data.iframeId == "model-viewer-3d-reference") {
                        setReferenceModelStatus('error');
                    } else if (message.data.iframeId == "model-viewer-3d") {
                        setModel3DStatus('error');
                    }
                } else if (message.data.status == "loading") {
                    console.log("Model Viewer is loading");
                    if (message.data.iframeId == "model-viewer-3d-reference") {
                        setReferenceModelStatus('loading');
                    } else if (message.data.iframeId == "model-viewer-3d") {
                        setModel3DStatus('loading');
                    }
                }
            }
        };

        window.addEventListener('message', handleOnMessage);
        return () => window.removeEventListener('message', handleOnMessage);
    }, []);


    const takeSnapshot = async () => {
        try {
            setSnapshotLoader(true);
            const hideLoading = message.loading("Capturing view for feedback...", 0); // 0 = infinite until manually closed
            let base_url = ENVIRONMENT.getBaseURL(productAssetData.platform);
            let reference_img_plaform  = selectedReferenceAsset?.platform;
            if (compareView) {
                let preview_img = selectedPreviewAsset.url;
                let reference_img = selectedReferenceAsset.link;
                if (previewModelSelected) {
                    const blob = await requestBlobFromViewer("model-viewer-3d");
                    let key = "test_files/model_snapshots/" + product_id + "/preview" + "_" + Date.now() + ".png";
                    preview_img = base_url + key;
                    await uploadImageAsync(key, blob);
                    setSignedUrl('');
                }
                if (referenceModelSelected) {
                    const blob = await requestBlobFromViewer("model-viewer-3d-reference");
                    let key = "test_files/model_snapshots/" + product_id + "/reference" + "_" + Date.now() + ".png";
                    reference_img = key;
                    await uploadImageAsync(key, blob);
                    setSignedUrl('');
                    reference_img_plaform = productAssetData?.platform;
                } else {
                    if (selectedReferenceAsset.platform) {
                        base_url = ENVIRONMENT.getBaseURL(selectedReferenceAsset.platform);
                    }
                    reference_img = reference_img.replace(base_url, '');
                }
                addInDatabase(reference_img, preview_img, hideLoading, reference_img_plaform)
            } else {
                const blob = await requestBlobFromViewer("model-viewer-3d");
                let key = "product_assets/comb_images/" + product_id + '/' + 'comb_' + (allProductQAImages.length + 1) + ".png";
                await uploadImageAsync(key, blob);
                addPreviewInDatabase('comb_' + (allProductQAImages.length + 1) + ".png", hideLoading)
            }
        } catch (e) {
            console.error("Snapshot failed:", e);
        }
    };

    const disableSnapshotBtn = () => {
        return snapshotLoader || referenecAssets?.length == 0 || (previewModelSelected && model3DStatus != 'ready' && compareView) || (referenceModelSelected && referenceModelStatus != 'ready' && compareView);
    }

    const addInDatabase = (reference_img, preview_img, hideLoading, platform = '') => {
        let payload = {
            product_id: product_id,
            action: 'create_new_combination_image',
            platform: productAssetData?.platform,
            reference_image: reference_img,
            preview_image: preview_img,
            index_number: allProductQAImages.length + 1,
            username: CUSTOMER_USERNAME,
        }
        if (platform) {
            payload['reference_img_platform'] = platform;
        }
        let api = ENVIRONMENT.POST_PRODUCT_CREATION_HELPER;
        axios.post(api, payload)
            .then(res => {
                selectRelevantImage('image_upload', -1, '', hideLoading)
                setViewType('feedback_view');
                setSnapshotLoader(false);
            })
    }

    const addPreviewInDatabase = (preview_img, hideLoading) => {
        let payload = {
            product_id: product_id,
            action: 'add_new_preview_image',
            platform: productAssetData?.platform,
            preview_image: preview_img,
            username: CUSTOMER_USERNAME
        }
        let api = ENVIRONMENT.POST_PRODUCT_CREATION_HELPER;
        axios.post(api, payload)
            .then(res => {
                selectRelevantImage('image_upload', -1, '', hideLoading)
                setViewType('feedback_view');
                setSnapshotLoader(false);
            })
    }


    const changeToCompareView = () => {
        setCompareView(!compareView);
    }


    const openReferenceAssets = () => {
        setRefImgModal(true);
    }


    async function checkZipForOBJandGLB(zipUrl, type = '') {
        const response = await fetch(zipUrl);
        const blob = await response.blob();

        const zip = await JSZip.loadAsync(blob);
        const files = Object.keys(zip.files);

        // Filter for top-level files only (no folder nesting)
        const topLevelFiles = files.filter(name => !name.includes('/') || name.lastIndexOf('/') === name.length - 1);
        if (type == '') {
            const hasOBJ = topLevelFiles.some(name => name.toLowerCase().endsWith('.obj'));
            const hasGLB = topLevelFiles.some(name => name.toLowerCase().endsWith('.glb'));
            const hasGLTF = topLevelFiles.some(name => name.toLowerCase().endsWith('.gltf'));

            // Decide if the zip is valid (change logic if only .obj is required)
            if (hasOBJ || hasGLB || hasGLTF) {
                console.log('Valid zip: contains .obj top level ^');
                return true;
            } else {
                console.log('Invalid zip: required files not found at top level ^');
                return false;
            }
        } else {
            console.log(topLevelFiles)
            return topLevelFiles.some(name => name.toLowerCase().endsWith(type));
        }
    }

    return (
        <Row className={`${viewType == 'comparison_view' ? `` : `disp-none`} w-100 ${initialLoader && previewAssets?.length == 0 || (!(IS_MS_PROVIDER && (productData?.customer_username == MANAGED_CUSTOMER_USERNAME || productData?.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted" && productData?.model_status == 4) ? `blur-canvas` : ``}`}>
            <Col span={compareView ? 12 : 24} className={`w-100 ${compareView ? `card-border-right` : ``}`}>
                {compareView ? '' : <div className='comparison-btn-qa right'>
                    <Button className='nav-btns black-grey f-14' onClick={changeToCompareView}>
                        <ArrowLeftOutlined />&nbsp;Compare to References
                    </Button>
                </div>}
                <div className={`manrope f-14 black product-comparison-img-tag left`}>{previewModelSelected || !compareView ? '3D Model Preview' : 'Preview'}</div>

                {!previewModelSelected && selectedPreviewAsset && compareView &&
                    <Card className='product-qa-img'>
                        <ZoomImage className="product-qa-image-zoom comparison-view"
                            image={selectedPreviewAsset?.url} />
                    </Card>}
                {previewAssets?.length == 0 && compareView ?
                    <Card className='product-qa-img'>
                        <Empty
                            className='position-empty-data'
                            description={
                                <span className="manrope f-14 black-085">
                                    No Preview Assets
                                </span>
                            }
                        />
                    </Card> : ''}

                <div id='model-inspector-frame' className={`model-inspector-viewer-customer-qa ${compareView ? `comparison` : ``} ${previewModelSelected || !compareView ? `` : `disp-none`}`}>
                    <iframe id='model-viewer-3d' className='model-inspector-frame-customer' src={FileConstants.ModelInspector + product_id} />
                </div>

                {previewImageLoader && compareView ?
                    <LoadingOutlined className='image-loader-qa' />
                    : ""}
                {compareView ? <div className='img-selector-pos'>
                    <div className='justify-in-start img-options-bg' style={{ gap: 8 }}>
                        <Card onClick={() => { selectPreview('/img/3d.jpg', 'model') }} className={`qa-comp-card card-img-dim ${previewModelSelected ? `selected` : ``} cursor-pointer`}>
                            <img src={'/img/3d.jpg'} />
                        </Card>
                        {previewAssets?.map((img, index) => (
                            <Card onClick={() => { selectPreview(img, 'img') }} className={`qa-comp-card ${!previewModelSelected && img.url == selectedPreviewAsset?.url ? `selected` : ``}`}>
                                <img className='qa-comp-card-img' src={img.url} />
                            </Card>
                        ))}
                    </div>
                </div> : ''}
                {compareView ? '' :
                    <div className='pos-button'>
                        <Tooltip title={<span className='manrope f-12 white'>{snapshotLoader ? `Capturing view...` : `Click here to capture view and add feedback.`}</span>}>
                            <span>
                                <Button className="nav-btns black round pd-16 f-14" disabled={snapshotLoader || (!compareView && model3DStatus != 'ready')} onClick={takeSnapshot}>
                                    <div className="capture-btn-content">
                                        <img src={"/img/camera_snapshot.svg"} width="30px" height="30px" alt="Capture" />
                                        <span className="capture-text">Capture View</span>
                                    </div>
                                </Button>
                            </span>
                        </Tooltip>
                    </div>}
            </Col>


            <Col span={12} className={`w-100 ${compareView ? `` : `disp-none`}`}>
                <div className={`manrope f-14 black product-comparison-img-tag left`}>{'References'}</div>
                <div className='comparison-btn-qa right'>
                    <Button className='nav-btns black-grey f-14' onClick={changeToCompareView}>
                        Hide References&nbsp;<ArrowRightOutlined />
                    </Button>
                </div>

                {!referenceModelSelected && selectedReferenceAsset &&
                    <Card className='product-qa-img'>
                        <ZoomImage className="product-qa-image-zoom comparison-view"
                            image={selectedReferenceAsset?.link} />
                    </Card>}
                {!referenceImageLoader && referenecAssets?.length == 0 ?
                    <Card className='product-qa-img'>
                        <Empty
                            className='position-empty-data'
                            description={
                                <span className="manrope f-14 black-085">
                                    No References Assets
                                </span>
                            }
                        />
                    </Card> : referenceImageLoader && referenecAssets?.length == 0 ?
                        <Card className='product-qa-img'>
                            <div className="product-qa-image-zoom comparison-view"></div>
                        </Card> : ''}
                <Row id='model-inspector-frame-reference' className={`model-inspector-viewer-customer-qa ${compareView ? `comparison` : ``} ${referenceModelSelected && selectedReferenceAsset ? `` : `disp-none`}`}>
                    <iframe id='model-viewer-3d-reference' className='model-inspector-frame-customer' src={FileConstants.ModelInspector + product_id} />
                </Row>
                {refImageLoader || referenceImageLoader ?
                    <LoadingOutlined className='image-loader-qa' />
                    : ""}

                <div className='img-selector-pos-border justify-in-start display-flex no-wrap'>
                    <div className='overflow-logic'>
                        <div className='justify-in-start' style={{ gap: 8, padding: "8px" }}>
                            {referenecAssets?.map((img, index) => (
                                ['jpg', 'jpeg', 'png', 'svg'].includes(img.format) ?
                                    <Card onClick={() => { selectReference(img, 'img', index) }} className={`qa-comp-card ${img.link == selectedReferenceAsset?.link ? `selected` : ``}`}>
                                        <img className='qa-comp-card-img' src={img.link} />
                                    </Card> :
                                    ['glb'].includes(img.format) ?
                                        <Card onClick={() => { selectReference(img, 'model', index) }} className={`qa-comp-card card-img-dim ${img.link == selectedReferenceAsset?.link && referenceModelSelected ? `selected` : ``} cursor-pointer`}>
                                            <img className='qa-comp-card-img' src={"/img/glb_file.png"} />
                                        </Card> :
                                        ['obj'].includes(img.format) ?
                                            <Card onClick={() => { selectReference(img, 'model', index) }} className={`qa-comp-card card-img-dim ${img.link == selectedReferenceAsset?.link && referenceModelSelected ? `selected` : ``} cursor-pointer`}>
                                                <img className='qa-comp-card-img' src={"/img/obj_icon.png"} />
                                            </Card> :
                                            <Card onClick={() => { selectReference(img, 'model', index) }} className={`qa-comp-card card-img-dim ${img.link == selectedReferenceAsset?.link && referenceModelSelected ? `selected` : ``} cursor-pointer`}>
                                                <img className='qa-comp-card-img' src={'/img/zip_file.png'} />
                                            </Card>
                            ))}
                        </div>
                    </div>
                    <Button disabled={referenecAssets?.length > 0 && referenceImageLoader} className="nav-btns black round f-16 pd-16 ml-8 mr-8" onClick={openReferenceAssets}>
                        {referenecAssets?.length > 0 && referenceImageLoader ?
                            <LoadingOutlined /> :
                            <PlusOutlined />}
                    </Button>
                </div>

                <div data_tut="reactour__tourStep2" className={`pos-button compare-btn`}>
                    <Tooltip title={<span className='manrope f-12 white'>{snapshotLoader ? `Capturing view...` : `Click here to capture a comparison image and add feedback.`}</span>}>
                        <span>
                            <Button className="nav-btns black round pd-16 f-14" disabled={disableSnapshotBtn()} onClick={takeSnapshot}>
                                <div className="capture-btn-content">
                                    <img src={"/img/camera_snapshot.svg"} width="30px" height="30px" alt="Capture" />
                                    <span className="capture-text">Capture View</span>
                                </div>
                            </Button>
                        </span>
                    </Tooltip>
                </div>
            </Col>
        </Row>)

}

export default ProductComparisonViewer;